import React from "react";
import { useDispatch } from "react-redux";
import Card from "components/card";
import Button from "components/button";
import { Popover } from "antd";
import { USABLE_ICONS } from "variables/constants";
import { formatDateRange } from "utils/index";
import { doEmployeeAwardUpdate } from "../../../../redux/employeeaward/employeeAwardState"; 

const AwardCard = ({
  recordData,
}) => {
  const dispatch = useDispatch();
  
  const doUpdate = (data) => dispatch(doEmployeeAwardUpdate(data));

  const isShared = recordData?.ema_is_shared === 1;

  const IconComponent =
    recordData?.award_icon && USABLE_ICONS[recordData?.award_icon] ? USABLE_ICONS[recordData?.award_icon] : null;

  const handleShare = () => {
    doUpdate({
      ema_id: recordData?.ema_id,
      ema_is_shared: 1,
    });
  };

  return (
    <Card className="flex flex-col gap-6 rounded-2xl border-2 border-purple-200 dark:border-purple-700 bg-gradient-to-br from-purple-50 to-white dark:from-purple-900 dark:to-white/5">
      <div className="p-6">
        <div className="flex flex-col items-center text-center nomination">
          <Popover
            content={recordData?.award_title}
            trigger="hover"
            placement="top"
            overlayClassName="reward-popover"
          >
            <div
              className={`icon-style ${recordData?.award_color_class.toLowerCase()} w-10 h-10 !rounded-full shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}
            >
              {IconComponent &&
                React.createElement(IconComponent, {
                  className: "w-5 h-5 text-white"
                })}
            </div>
          </Popover>

          <h4 className="font-semibold mt-4 title-text">{recordData?.award_title}</h4>
          <p className="text-sm mt-1 muted-text">
            {recordData?.ema_issued_at 
              ? formatDateRange(recordData.ema_issued_at, null, true, true).replace(/\s\d+,/, '')
              : "-"
            }
          </p>

          <Button
            type="button"
            onClick={handleShare}
            disabled={isShared}
            className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all border bg-white hover:bg-slate-100 shrink-0 h-8 rounded-lg gap-1.5 px-3 w-full mt-4 dark:bg-white/20 dark:text-white hover:shadow-none"
          >
            Share Achievement
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default AwardCard;